;(function() {
  'use strict'

  angular.module('app.core').component('channelEmbedData', {
    controller: Controller,
    templateUrl: 'channel-embed-data.html',
    bindings: {
      channel: '<',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.onToggle = onToggle
    ctrl.onRespondentIdChange = onRespondentIdChange

    function onInit() {
      //...
    }

    function onToggle() {
      ctrl.channel.embedData.enabled = !ctrl.channel.embedData.enabled
    }

    function onRespondentIdChange(param, selected, index) {
      param.isRespondentId = selected
      if (param.isRespondentId) {
        _.each(ctrl.channel.embedData.params, function(param, idx) {
          if (idx === index) return
          param.isRespondentId = false
        })
      }
    }
  }
})()
